// Festival-wide constants and small editorial blocks. The site is
// hand-edited each year, so these are deliberately plain objects rather
// than fetched from a CMS — the festival team can grep + edit one file
// to update content year over year.

export const festival = {
  name: "Rhythms on the Rio",
  edition: "2026",
  tagline: "Three days of live music on the banks of the Rio Grande.",
  // Poster spans Thursday early entry through Sunday — match it.
  // Music programming is Friday–Sunday; Thursday is camping/early entry only.
  dates: "July 30 – August 2, 2026",
  datesShort: "Jul 30 – Aug 2, 2026",
  city: "Del Norte, Colorado",
  address: "12510 W HWY 112, Del Norte, CO 81132",
  ticketsUrl: "https://events.humanitix.com/rhythms-on-the-rio-2026",
  email: "info@rhythmsontherio.com",
  emailVolunteer: "volunteer@rhythmsontherio.com",
  emailSponsor: "sponsor@rhythmsontherio.com",
  emailVendor: "vendor@rhythmsontherio.com",
  emailPress: "press@rhythmsontherio.com",
  emailArtists: "talent@rhythmsontherio.com",
  mailing: "PO Box 2, South Fork, CO 81154",
  facebook: "https://facebook.com/rhythmsontherio",
  instagram: "https://instagram.com/rhythmsontherio",
};

// Top-level nav. Tickets is rendered as a CTA pill (opens overlay),
// not a route. The Home item uses `exact: true` so NavLink only marks
// it active on "/" and not on every page (since "/" is a prefix of
// every URL).
export const navItems = [
  { label: "Home", path: "/", exact: true },
  { label: "About", path: "/about" },
  { label: "Lineup", path: "/lineup" },
  { label: "Participate", path: "/participate" },
];
